import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostById } from '../redux/postsSlice';
import { RootState, AppDispatch } from '../redux/store';
import { Container, Typography } from '@mui/material';

const PostDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const post = useSelector((state: RootState) => state.posts.selectedPost as { id: number; title: string; body: string } | null);

  useEffect(() => {
    if (id) dispatch(fetchPostById(id));
  }, [dispatch, id]);

  return (
    <Container>
      {post && (
        <>
          <Typography variant="h5">Post ID: {post.id}</Typography>
          <Typography variant="h6">Title: {post.title}</Typography>
          <Typography>Body: {post.body}</Typography>
        </>
      )}
    </Container>
  );
};

export default PostDetail;
